import { TrendUp, ShoppingCart, ArrowDownLeft, ArrowUpRight } from "@phosphor-icons/react";
import { money } from "@/lib/api";

const CFG = [
  ["sales", "Günlük Satış", "fatura", TrendUp, "kpi-day-sales", { bar: "bg-blue-600", bg: "bg-blue-50", border: "border-blue-200", text: "text-blue-900", icon: "bg-blue-600" }],
  ["purchases", "Günlük Alış", "fatura", ShoppingCart, "kpi-day-purchases", { bar: "bg-amber-500", bg: "bg-amber-50", border: "border-amber-200", text: "text-amber-900", icon: "bg-amber-500" }],
  ["collections", "Günlük Tahsilat", "işlem", ArrowDownLeft, "kpi-day-collections", { bar: "bg-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", text: "text-emerald-900", icon: "bg-emerald-600" }],
  ["payments", "Günlük Ödeme", "işlem", ArrowUpRight, "kpi-day-payments", { bar: "bg-red-600", bg: "bg-red-50", border: "border-red-200", text: "text-red-900", icon: "bg-red-600" }],
];

export default function DayKpis({ t }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {CFG.map(([key, label, unit, Icon, id, c], i) => (
        <div key={key} className={`fade-up lift relative overflow-hidden rounded-[4px] border ${c.border} ${c.bg}`} style={{ animationDelay: `${i * 50}ms` }} data-testid={id}>
          <div className={`absolute inset-y-0 left-0 w-1.5 ${c.bar}`} />
          <div className="py-5 pl-6 pr-5">
            <div className="flex items-center justify-between">
              <span className={`text-xs font-bold uppercase tracking-[0.14em] ${c.text}`}>{label}</span>
              <span className={`flex h-9 w-9 items-center justify-center rounded-full text-white ${c.icon}`}><Icon size={17} weight="bold" /></span>
            </div>
            <div className={`mt-3 font-num text-2xl font-semibold ${c.text}`} data-testid={`${id}-value`}>{money(t[key])}</div>
            <div className={`mt-1 text-xs font-medium ${c.text} opacity-70`}>{t[`${key}_count`]} {unit}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
